import { createContext, useContext, type RefObject } from "react";

/**
 * The shell's content scroll element (the `<main>` that owns the vertical
 * scroll, spec §2). Virtualized lists inside the routed content must observe
 * this element, not the window, because the window no longer scrolls.
 */
export const ScrollAreaContext = createContext<RefObject<HTMLElement | null> | null>(null);

/** Returns the shell content scroll element ref, or null outside the shell. */
export function useScrollArea() {
  return useContext(ScrollAreaContext);
}
